// extracted by mini-css-extract-plugin
export var orderDetails = "_u7-2";
export var orderImage = "_u7-1";
export var orderMeta = "_u7-3";
export var orderSummary = "_u7-0";
export var rightArrow = "_u7-4";